import {create} from 'zustand'

export const useRoomsStore = create((set) => ({
    rooms: [],
    setRooms: (rooms) => set(() => ({rooms})),
}));
